import { Box, Flex, Title } from "@mantine/core";
import TripAnalyzer from "src/components/TripAnalyzer";

export const TripAnalyzerRoute = () => {
    return (
        <Flex p="xl" direction="column" gap="md">
            <Flex justify="space-between">
                <Title lh={2} c="purple.8" order={2} style={{ textTransform: "uppercase" }}>
                    Trip Analyzer
                </Title>
            </Flex>
            <Box>
                <TripAnalyzer />
            </Box>
        </Flex>
    );
};
